<ion-header class="preview-images__header">
  <ion-row class="preview-images__header-row" *ngIf="!isSingleImagePreviewMode">
    <div class="preview-images__back-icon" (click)="handleBack()">
      <ion-img [src]="backArrow"></ion-img>
    </div>
    <div>{{ 'preview_images_component.images' | translate }}</div>
  </ion-row>
  <ion-row class="preview-images__header-row" *ngIf="isSingleImagePreviewMode">
    <div class="preview-images__back-icon" (click)="goToViewAllImages()">
      <ion-img [src]="backArrow"></ion-img>
    </div>
    <div>{{ 'preview_images_component.imagePreview' | translate }}</div>
  </ion-row>
</ion-header>
<ion-content class="preview-images__content">
  <ion-row *ngIf="!isSingleImagePreviewMode">
    <ion-col [size]="4" *ngFor="let file of publicPaths; let idx = index">
      <ion-card>
        <img [src]="file" />
        <ion-card-content>
          <ion-row>
            <ion-col>
              <ion-button (click)="previewImage(file)">{{ 'preview_images_component.preview' | translate }}</ion-button>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isSingleImagePreviewMode" class="preview-images__full-height">
    <ion-card class="preview-images__image-preview-container">
      <img [src]="previewSingleImagePublicPath" />
    </ion-card>
  </ion-row>
</ion-content>
